import React from 'react';
import {
  config,
  TYPE_GTI,
  TYPE_DEFAULT,
  TYPE_FIMLAB,
  TYPE_HEARING_DEVICE_FIXING,
  TYPE_HEARING_DEVICE_MODELING,
  TYPE_REFERRAL,
  TYPE_VIDEO_CONFERENCE,
  TYPE_COXA_TREATMENT_PERIOD,
  TYPE_SLEEP_CLINIC,
} from '../../../definitions/TimelineItems';
import TimelineItem from './TimelineItem';
import LaboratoryNotificationDescription from './laboratory/LaboratoryNotificationDescription';
import { FormattedMessage, injectIntl } from 'react-intl';
import Urls from '../../../definitions/Urls';

import Row from '../../../components/tag/Row';
import Span from '../../../components/tag/Span';
import Logger from '../../../utils/Logger';
import { OTLink } from '../../../components/tag/OTLink';
import VideoConferenceLink from './VideoConferenceLink';
import QLink from './QLink';
import {
  getDepartmentabbreviation,
  getDepartmentDisplay,
  getInstructions,
  hasInstructions,
  isPhoneVisit,
  mapVisibleQuestionnaires,
  hasAdditionalCoxaInfo,
  isRemoteVisit,
  getVideoConferenceLink,
} from '../../../utils/TimelineUtils';
import GTITimelineItem from './gti/GTITimelineItem';
import HospitalWardTimelineItem from './hospitalward/HospitalWardTimelineItem';
import { getLogo } from '../../../utils/LogoUtils';
import { notEmpty } from '../../../utils/Functions';
import OTIcon from '../../../components/tag/OTIcon';
import Instructions from './Instructions';
import CommonInstructions from './CommonInstructions';

let { id: module_id } = module;
const logger = new Logger(module_id);

export const resolveReminder = (isKidneyDept, data) => {
  // kidney dept has separate reminder
  if (isKidneyDept) return null;

  // if visit is phone call, return phone reminder.
  /*if (isPhoneVisit(data)) {
    return 'timelineitem.phone.reminder';
  }*/

  // If visit is Coxa treatment period (hoitojakso), show specified reminder.
  if (data.type === TYPE_COXA_TREATMENT_PERIOD) {
    return 'timelineitem.coxa.treatmentperiod.info.reminder';
  }

  // Otherwise return default reminder concerning visit location.
  return 'timelineitem.location.reminder';
}

const TimelineItemWrapper = ({
  qIsFetching,
  data,
  past,
  showRescheduleTransitionModal,
  navigateToReschedule,
  history,
  linkkipalvelu,
  intl,
}) => {
  let visibleQuestionnaires = mapVisibleQuestionnaires(data);

  const getLinkValue = (departmentAbbr) => {
    return (
      linkkipalvelu.Toimipistetiedot &&
      linkkipalvelu.Toimipistetiedot[departmentAbbr]
    );
  };

  const hasLinkValue = (linkValue) => {
    return (
      linkValue &&
      linkValue.length !== 0 &&
      linkValue !== 'fetching' &&
      linkValue !== 'error' &&
      linkValue !== null &&
      linkValue[0] !== null &&
      linkValue[0] !== null &&
      linkValue.toString() !== '' &&
      linkValue.toString() !== ' '
    );
  };

  if (data?.config?.type === 'imaging') {
    return (
      <TimelineItem
        {...config[data.type]}
        past={past}
        data={data}
        date={data.date}
        contentDescription={
          <>
            <p className="card-department-info">
              {getDepartmentDisplay(data.department)}
            </p>
          </>
        }
      />
    );
  } else if (data?.config?.type === 'hospitalWard') {
    return (
      <HospitalWardTimelineItem data={data} linkkipalvelu={linkkipalvelu} />
    );
  }
  switch (data.type) {
    case TYPE_VIDEO_CONFERENCE: {
      let unitLogo = null;
      const logoFromLinkkipalvelu =
          linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid];

      if (
          logoFromLinkkipalvelu &&
          logoFromLinkkipalvelu !== 'fetching' &&
          logoFromLinkkipalvelu !== 'error' &&
          logoFromLinkkipalvelu[0] !== null
      ) {
        const logoAttr = getLogo(logoFromLinkkipalvelu[0].toString());
        if (logoAttr) {
          unitLogo = (
              <img
                  className="card-logo_image"
                  alt={intl.formatMessage({ id: logoAttr.altTextId })}
                  src={logoAttr.logoSrc}
              />
          );
        }
      }

      return (
        <TimelineItem
          {...config[data.type]}
          past={past}
          data={data}
          date={data.date}
          logo={unitLogo}
          contentDescription={
            <>
              <p>
                <span style={{ textDecoration: 'underline' }}>
                  {getDepartmentDisplay(data.department)}
                </span>
              </p>
            </>
          }
        />
      );
    }
    case TYPE_FIMLAB:
      let logo = null;
      /* Sydänsairaala logo is displayed based on organisation id 22773 */
      /*if (data.organisation === '22773') {
        let logoAttr = getLogo('SYDAN');
        logo = (
          <img
            className="card-logo_image"
            alt={intl.formatMessage({ id: `alt.text.${logoAttr.altTextId}` })}
            src={logoAttr.logoSrc}
          />
        );
      }*/

      return (
        <TimelineItem
          {...config[data.type]}
          past={past}
          data={data}
          date={data.date}
          logo={logo}
          contentDescription={
            <>
              <p>
                <span>
                  <FormattedMessage id={`fimlab.department`} />
                </span>
              </p>
            </>
          }
          contentExpanded={
            <LaboratoryNotificationDescription
              isNotification={false}
              {...data}
            />
          }
        />
      );
    /* If imaging feature is off, this type should never occur, thus it's unnecesary to check in here. */
    case TYPE_GTI:
      return (
        <GTITimelineItem
          past={past}
          data={data}
          date={data.date}
          instructions={
            hasInstructions(data, linkkipalvelu) &&
            getInstructions(data, linkkipalvelu)
          }
          qIsFetching={qIsFetching}
          visibleQuestionnaires={visibleQuestionnaires}
          linkValue={getLinkValue(getDepartmentabbreviation(data.department))}
          hasLink={hasLinkValue}
        />
      );

    case TYPE_REFERRAL: {
      const departmentDisplay = getDepartmentDisplay(data.department);

      const titleMessage = () => {
        return intl.messages[
          `referral.timeline.title.${data.referralState}.${data.referralStateSpecifier}`
        ]
          ? `referral.timeline.title.${data.referralState}.${data.referralStateSpecifier}`
          : `referral.timeline.title.vastaanotettu`;
      };

      const descriptionMessage = () => {
        return intl.messages[
          `referral.timeline.description.${data.referralState}.${data.referralStateSpecifier}`
        ]
          ? `referral.timeline.description.${data.referralState}.${data.referralStateSpecifier}`
          : `referral.timeline.description.vastaanotettu`;
      };

      const referralConfig = {
        ...config[data.type],
        title: {
          ...config[data.type].title,
          defaultMessage: intl.formatMessage({ id: 'referral.title.default' }),
          message: titleMessage(),
        },
      };

      return (
        <TimelineItem
          {...referralConfig}
          past={past}
          data={data}
          date={data.date}
          contentDescription={
            <>
              <p>
                <span>
                  <FormattedMessage
                    id={descriptionMessage()}
                    values={{
                      department: <u>{departmentDisplay}</u>,
                    }}
                  />
                  <FormattedMessage
                    id={'referral.omakanta'}
                    values={{
                      br: <br />,
                      link: (
                        <a target={'_blank'} href={Urls.omaKanta}>
                          OmaKanta-palvelussa
                          <i className="icon-external-link" />{' '}
                        </a>
                      ),
                    }}
                  />
                </span>
              </p>
            </>
          }
        />
      );
    }
    case TYPE_DEFAULT:
    case TYPE_HEARING_DEVICE_FIXING:
    case TYPE_HEARING_DEVICE_MODELING:
    case TYPE_SLEEP_CLINIC:
    case TYPE_COXA_TREATMENT_PERIOD:
      const isKidneyDept =
        data.department && new RegExp(/\(MUNP\)/).test(data.department);

      const linkValue = getLinkValue(
        getDepartmentabbreviation(data.department)
      );

      const hasLink = hasLinkValue(linkValue);

      let unitLogo = null;
      const logoFromLinkkipalvelu =
        linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid];

      if (
        logoFromLinkkipalvelu &&
        logoFromLinkkipalvelu !== 'fetching' &&
        logoFromLinkkipalvelu !== 'error' &&
        logoFromLinkkipalvelu[0] !== null
      ) {
        const logoAttr = getLogo(logoFromLinkkipalvelu[0].toString());
        if (logoAttr) {
          unitLogo = (
            <img
              className="card-logo_image"
              alt={intl.formatMessage({ id: logoAttr.altTextId })}
              src={logoAttr.logoSrc}
            />
          );
        }
      }
      const showCoxaInfo = hasAdditionalCoxaInfo(data);
      const _hasInstructions = hasInstructions(data, linkkipalvelu);

      const reminder = resolveReminder(isKidneyDept, data);
      const hasExpanded =
        hasLink ||
        isKidneyDept ||
        notEmpty(visibleQuestionnaires) ||
        data.canBeRescheduled ||
        _hasInstructions;

      return (
        <TimelineItem
          {...config[data.type]}
          past={past}
          data={data}
          date={data.date}
          logo={unitLogo}
          contentDescription={
            <>
              <p>
                <span>{getDepartmentDisplay(data.department)}</span>
              </p>
              {/* Render reminder text if it's resolved */}
              {/*
              {reminder && (
                <p className="card__reminder">
                  <FormattedMessage id={reminder} />
                </p>
              )}
              {showCoxaInfo && (
                <FormattedMessage
                  id={'timelineitem.coxa.additional.info.reminder'}
                >
                  {(txt) => <p className={'card__reminder'}>{txt}</p>}
                </FormattedMessage>
              )}
              */}
            </>
          }
          contentExpanded={
            hasExpanded ? (
              <>
                {(qIsFetching || notEmpty(visibleQuestionnaires)) && (
                  <ul>
                    {visibleQuestionnaires.map((q) => (
                      <QLink
                        key={q.id}
                        qIsFetching={qIsFetching}
                        data={data}
                        questionnaire={q}
                      />
                    ))}
                  </ul>
                )}
                {data.canBeRescheduled && (
                  <>
                    <Row>
                      <Span>
                        <i className="card-icon icon-calendar" />{' '}
                        <button
                          className="card-link"
                          onClick={() => {
                            if (
                              data.canBeRescheduled === 'CAN_RESCHEDULE_ONCE'
                            ) {
                              showRescheduleTransitionModal(data.id);
                            } else if (
                              data.canBeRescheduled ===
                              'CAN_RESCHEDULE_MULTIPLE'
                            ) {
                              navigateToReschedule(data.id, history);
                            }
                          }}
                        >
                          <FormattedMessage id={'move.time'} />
                        </button>
                      </Span>
                    </Row>
                  </>
                )}
                {hasLink && (
                  <>
                    <div className="span12">
                      <i className="card-icon icon-info" />{' '}
                      <OTLink
                        target="_blank"
                        onClick={(e) => e.stopPropagation()}
                        link={linkValue}
                        isExternal
                        className="card-link"
                      >
                        <FormattedMessage
                          id={`${module_id}.MUNP.careUnitDetails`}
                        />
                      </OTLink>
                      <OTIcon
                        style={{ padding: '2px' }}
                        config={{
                          type: 'fa',
                          name: 'icon-external-link',
                          color: 'blue',
                        }}
                      />
                    </div>
                  </>
                )}
                {_hasInstructions && (
                  <div className={'instructions'}>
                    <h3>
                      <FormattedMessage id={'visiting.instructions'} />
                    </h3>
                    <CommonInstructions
                      instructions={getInstructions(data, linkkipalvelu)}
                    />
                  </div>
                )}

                {isKidneyDept && (
                  <>
                    <div className="row-fluid">
                      <div className="span6">
                        <i className="card-icon icon-list-ul" />{' '}
                        <OTLink
                          link="/questionnaires"
                          onClick={(e) => e.stopPropagation()}
                          className="card-link"
                        >
                          <FormattedMessage
                            id={`${module_id}.MUNP.questionnaires`}
                          />
                        </OTLink>
                      </div>
                    </div>
                    <div className="row-fluid">
                      <div className="span12">
                        <i className="card-icon icon-file" />{' '}
                        <OTLink
                          target="_blank"
                          onClick={(e) => e.stopPropagation()}
                          link={Urls.patientFees}
                          isExternal
                          className="card-link"
                        >
                          <FormattedMessage
                            id={`${module_id}.MUNP.patientFees`}
                          />
                        </OTLink>
                      </div>
                    </div>
                    <div className="row-fluid">
                      <div className="span12">
                        <p
                          className="ot-notification__description--small"
                          style={{ color: 'black' }}
                        >
                          <FormattedMessage
                            id={`${module_id}.MUNP.attention`}
                            values={{
                              i: (chunks) => <i>{chunks}</i>,
                              br: <br />,
                            }}
                          />
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </>
            ) : null
          }
        />
      );
    default:
      return null;
  }
};

export default injectIntl(TimelineItemWrapper);
